import Grid from '@mui/material/Grid'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import Card from 'ui/atoms/Card/Card'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import SystemMessageBanner from 'ui/components/SystemMessageBanner/SystemMessageBanner'
import View from 'ui/components/View/View'
import UiConfig from 'ui/uiConfig/UiConfig'

export default function ReferenceGuidesView(): ReactElement {
  const { t } = useTranslation()

  return (
    <View header={<ModuleHeader infoHeader={t('Reference guides')} />}>
      <SystemMessageBanner module="referenceguides" />
      <Grid size={{ xs: 12 }}>
        <Card collapsible>
          <UiConfig type="reference_guides" />
        </Card>
      </Grid>
    </View>
  )
}
